import styled from 'styled-components';
import IconArrowDownCircleOutline from './IconArrowDownCircleOutline';
var IconArrowUpCircleOutline = /*#__PURE__*/styled(IconArrowDownCircleOutline).withConfig({
  displayName: "IconArrowUpCircleOutline",
  componentId: "c11n-8-111-1__sc-ia4k1h-0"
})(["transform:rotate(180deg);"]);
export default IconArrowUpCircleOutline;